<template>
  <div>
    <v-data-table
      :headers="_headers"
      :items="item"
      hide-default-footer
      class="elevation-1"
    />
  </div>
</template>
<script>
export default {
  components: {
  },
  props: {
    loading: {
      type: Boolean,
      defualt() {
        return false;
      },
    },
    title: {
      type: String,
      default() {
        return "User Growth";
      },
    },
    item: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {
   _headers(){

    return [
       {
          text: "Rank",
          align: "left",
          sortable: true,
          value: "rank",
        },
        {
          text: this.$t("charge_point_id"),
          align: "left",
          sortable: true,
          value: "charge_point_id",
        },
        {
          text: this.$t("location"),
          align: "left",
          sortable: true,
          value: "location_name",
        },
        {
          text: "Total Revenue",
          align: "left",
          sortable: true,
          value: "total_revenue",
        },
        {
          text: "Total Sessions",
          align: "left",
          sortable: true,
          value: "total_sessions",
        },
     
    ]
   }
  },
};
</script>
